import "hammerjs";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";


import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import Amplify from "aws-amplify";

if (environment.production) {
  enableProdMode();
}

declare global {
  interface Window {
    setAccessToken: any;
    webViewClose: any;
    Android: any;
  }
}

Amplify.configure({
  Auth: {
    region: environment.region,
    userPoolId: environment.userPoolId,
    userPoolWebClientId: environment.userPoolWebClientId,
  },
});

const init = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule).then(()=>{
      window.Android.showLoader(false);
    })
    .catch((err) => console.error(err));
};

if(window.Android) {
  // opening via Android
  const url_string = window.location.href;
  const isWebviewJourney = new URL(url_string).searchParams.get('campaign') === 'app_paylater' ||
                            new URL(url_string).searchParams.get('campaign') === 'app_termloans';
  
  if(!isWebviewJourney) {
    localStorage.clear();
    init();
  }
} else {
  init();
}

function setAccessToken(accessToken) {
  if (accessToken) {
    window.localStorage.clear();
    window.localStorage.setItem("X-AUTH-TOKEN", accessToken);
    if(new URL(window.location.href).searchParams.get('campaign') === 'app_paylater') {
      window.localStorage.setItem('isPayLater', 'true');
    } else if(new URL(window.location.href).searchParams.get('campaign') === 'app_termloans') {
      window.localStorage.setItem('isTermLoans', 'true');
    }
    init();
  } else {
    init();
  }
}

window.setAccessToken = setAccessToken;
